module.exports = __webpack_public_path__ + "review.jpg?19f9c460f310a299c6da3e8d67416b9d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/review.jpg
// module id = 35
// module chunks = 0